import React, { useMemo } from "react";
import Select from "react-select";
import { selectStyles } from "../../utils";
import { MdSearch, MdRefresh } from "react-icons/md";

/** `statusSelectOptions` — built in parent from `API_KEY_STATUS` (avoids duplicate utils + circular init issues). */
export default function ApiKeysFiltersBar({ draftFilters, setDraftFilters, onSearch, onReset, statusSelectOptions = [] }) {

  const statusValue = useMemo(() => {
    const v = (draftFilters.status || "").trim();
    if (!v) return null;
    return (statusSelectOptions || []).find((o) => o.value === v);
  }, [draftFilters.status, statusSelectOptions]);

  return (
    <div className="list-page-filter-bar">
      <div className="list-page-filter-fields row g-3 align-items-end">
        <div className="list-page-filter-field col-12 col-lg-4">
          <div style={{ minWidth: 0, width: "100%" }}>
            <Select
              inputId="api-keys-status"
              instanceId="api-keys-status"
              classNamePrefix="ns-api-keys-status"
              isSearchable
              isClearable
              placeholder="Status"
              aria-label="Status"
              options={statusSelectOptions || []}
              value={statusValue}
              onChange={(opt) => setDraftFilters((d) => ({ ...d, status: opt?.value ?? "" }))}
              styles={selectStyles}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
            />
          </div>
        </div>
        <div className="list-page-filter-field list-page-filter-actions col-12 col-lg-4">
          <div className="add_app">
            <button type="button" className="add_app_btn btn_theme_primary" title="Apply filters" onClick={onSearch}>
              <MdSearch />
              <span>Search</span>
            </button>
            <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Reset filters" onClick={onReset}>
              <MdRefresh />
              <span>Reset</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
